export const clearKeysFromObject = (obj, keys) => {
  const result = {};

  for (const key in obj) {
    if (!keys.includes(key)) {
      result[key] = obj[key];
    }
  }

  return result;
};



// WEBPACK FOOTER //
// ./webapp/utils/object-format.js